import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";

export default function FilterModal({
  show,
  onHide,
  applyFilters,
  removeFilters,
  apidata,
}) {
  const [status, setStatus] = useState("");
  const [city, setCity] = useState("");
  const [jobId, setJobId] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [createdBy, setCreatedBy] = useState(""); // ✅ NEW STATE
  const [cityOptions, setCityOptions] = useState([]);
  const [jobIdOptions, setJobIdOptions] = useState([]);

  // ✅ Extract unique cities from jobId.city
  useEffect(() => {
    if (apidata && apidata.length > 0) {
      // Extract unique cities
      const uniqueCities = [
        ...new Set(
          apidata
            .map((item) => item.jobId?.city)
            .filter((city) => city && city.trim() !== ""),
        ),
      ];

      // Extract unique Job IDs
      const uniqueJobIds = [
        ...new Set(
          apidata
            .map((item) => item.jobId?.jobId)
            .filter((jobId) => jobId && jobId.trim() !== ""),
        ),
      ];

      setCityOptions(uniqueCities);
      setJobIdOptions(uniqueJobIds);
    }
  }, [apidata]);

  const handleApply = () => {
    // applyFilters({ status, city, date, createdBy }); // ✅ PASS createdBy
    applyFilters({
      status,
      city,
      jobId,
      fromDate,
      toDate,
      createdBy,
    });
    onHide();
  };

  const handleRemove = () => {
    setStatus("");
    setCity("");
    setJobId("");
    setFromDate("");
    setToDate("");
    setCreatedBy(""); // ✅ RESET
    removeFilters();
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Filter Options</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          {/* ✅ Status Filter */}
          <Form.Group className="mb-3">
            <Form.Label>Status</Form.Label>
            <Form.Select
              value={status}
              onChange={(e) => setStatus(e.target.value)}
            >
              <option value="">All</option>
              <option value="Pending">Pending</option>
              <option value="In-Progress">In-Progress</option>
              <option value="Hired">Hired</option>
              <option value="Rejected">Rejected</option>
              <option value="Closed">Closed</option>
            </Form.Select>
          </Form.Group>

          {/* ✅ City Filter */}
          <Form.Group className="mb-3">
            <Form.Label>City</Form.Label>
            <Form.Select value={city} onChange={(e) => setCity(e.target.value)}>
              <option value="">All</option>
              {cityOptions.map((cityName, index) => (
                <option key={index} value={cityName}>
                  {cityName}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          {/* ✅ Date Filter */}
          <Form.Group className="mb-3">
            <Form.Label>From Date</Form.Label>
            <Form.Control
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>To Date</Form.Label>
            <Form.Control
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </Form.Group>

          {/* ✅ ✅ ✅ CREATED BY FILTER */}
          {/* <Form.Group className="mb-3">
            <Form.Label>Created By</Form.Label>
            <Form.Select
              value={createdBy}
              onChange={(e) => setCreatedBy(e.target.value)}
            >
              <option value="">All</option>
              <option value="USER">User</option>
              <option value="TEAM">Admin / Team</option>
            </Form.Select>
          </Form.Group> */}
          <Form.Group className="mb-3">
            <Form.Label>Created By</Form.Label>
            <Form.Select
              value={createdBy}
              onChange={(e) => setCreatedBy(e.target.value)}
            >
              <option value="">All</option>

              {/* USER means: public users + regular registered users */}
              <option value="USER">User</option>

              {/* TEAM means: admin, superadmin, client manager */}
              <option value="TEAM">Admin / Team</option>
            </Form.Select>
          </Form.Group>

          {/* 💼 Job ID Filter */}
          <Form.Group className="mb-3">
            <Form.Label>Job ID</Form.Label>

            <Form.Select
              value={jobId}
              onChange={(e) => setJobId(e.target.value)}
            >
              <option value="">All</option>

              {jobIdOptions.map((jobIdValue, index) => (
                <option key={index} value={jobIdValue}>
                  {jobIdValue}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleRemove}>
          Remove Filters
        </Button>
        <Button variant="primary" onClick={handleApply}>
          Apply Filters
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
